import React, { useEffect } from 'react'
import { LoginMethodChooserTemplate } from '../../templates/LoginMethodChooserTemplate'

import Lurker from '../../../util/lurker'
import { getModalLoginExtraData } from '../../../util/experiments'

const lurker = new Lurker('login_method_chooser')

const LoginMethodChooserPage = ({
  email,
  allowedMethods,
  showHelpingModalLink,
  onBackClick,
  onForgotPasswordClick,
  onMagicLinkClick,
  onReactivationLinkClick,
  onPasswordMethodClick,
  onEmailMethodClick,
  onFacialRecognitionMethodClick,
  modalMode,
  abTests,
}) => {
  const onHelpLinkClick = () => {
    lurker.clickEvt('help_modal_open')
  }

  const onHelpLinkClose = () => {
    lurker.clickEvt('help_modal_close')
  }

  const onBackClickButton = () => {
    lurker.clickEvt('back_button')
    if (typeof onBackClick === 'function') {
      onBackClick()
    }
  }

  const onPasswordMethodClickButton = () => {
    lurker.clickEvt('password_method')
    if (typeof onPasswordMethodClick === 'function') {
      onPasswordMethodClick()
    }
  }

  const onEmailMethodClickButton = () => {
    lurker.clickEvt('email_method')
    if (typeof onEmailMethodClick === 'function') {
      onEmailMethodClick()
    }
  }

  const onPrivacyLinkClick = () => {
    lurker.clickEvt('privacy_button')
  }

  const onTermsLinkClick = () => {
    lurker.clickEvt('terms_button')
  }

  useEffect(() => {
    const extraData = getModalLoginExtraData(abTests, modalMode)
    if (extraData) {
      lurker.pageLoadWithExtraDataEvt('login_method_chooser', extraData)
    } else {
      lurker.pageLoadEvt()
    }
  }, [])

  return (
    <LoginMethodChooserTemplate
      email={email}
      allowedMethods={allowedMethods}
      showHelpingModalLink={showHelpingModalLink}
      onBackClick={onBackClickButton}
      onForgotPassword={onForgotPasswordClick}
      onMagicLinkClick={onMagicLinkClick}
      onReactivationLinkClick={onReactivationLinkClick}
      onHelpLinkClick={onHelpLinkClick}
      onHelpLinkClose={onHelpLinkClose}
      onPasswordMethodClick={onPasswordMethodClickButton}
      onEmailMethodClick={onEmailMethodClickButton}
      onFacialRecognitionMethodClick={onFacialRecognitionMethodClick}
      onPrivacyLinkClick={onPrivacyLinkClick}
      onTermsLinkClick={onTermsLinkClick}
      modalMode={modalMode}
      abTests={abTests}
    />
  )
}

export { LoginMethodChooserPage }
